import { useState } from "react";
import { ActionIconTile } from "@aisquare/ui";
import { CheckIcon, CopyIcon, ExternalLinkIcon, Share2Icon } from "lucide-react";
import { Section, VariantBlock } from "../lib/Section";

export function ActionIconTileDemo() {
  const [copied, setCopied] = useState(false);
  return (
    <Section
      id="action-icon-tile"
      title="ActionIconTile"
      description="The chat-chrome flat action tile (B19): rounded-square hairline icon control for action rows. Sibling of IconButton (round ghost) by design."
    >
      <VariantBlock label="Action row" caption="button + anchor forms; consumer swaps icon + aria-label for feedback">
        <div className="flex items-center gap-1.5">
          <ActionIconTile
            aria-label={copied ? "Link copied" : "Copy link"}
            onClick={() => {
              setCopied(true);
              setTimeout(() => setCopied(false), 1500);
            }}
          >
            {copied ? <CheckIcon /> : <CopyIcon />}
          </ActionIconTile>
          <ActionIconTile asChild aria-label="Open in Studio">
            <a href="https://aisquare.studio" target="_blank" rel="noopener noreferrer">
              <ExternalLinkIcon />
            </a>
          </ActionIconTile>
          <ActionIconTile aria-label="Share">
            <Share2Icon />
          </ActionIconTile>
          <ActionIconTile aria-label="Disabled example" disabled>
            <Share2Icon />
          </ActionIconTile>
        </div>
      </VariantBlock>
    </Section>
  );
}
